import { Api } from '../api';
import { lsb } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { GetSpecialOffersResponse, PostRequestRequest, PostRequestResponse, PostSpecialOfferRequest, PostSpecialOfferResponse } from './models';

export class LsbApi extends Api {
  static getSpecialOffers = (signal?: AbortSignal) => this.get<ApiResponse<GetSpecialOffersResponse[]>>({ url: lsb.specialOffers(), signal });

  static postSpecialOffer = (request: PostSpecialOfferRequest, signal?: AbortSignal) =>
    this.post<PostSpecialOfferRequest, ApiResponse<PostSpecialOfferResponse>>({ url: lsb.specialOffers(), data: request, signal });

  static postRequest = (request: PostRequestRequest, signal?: AbortSignal) =>
    this.post<PostRequestRequest, ApiResponse<PostRequestResponse>>({ url: lsb.requests(), data: request, signal });
}
